import { actions$ } from "mini-rx-store";
import { catchError, map, of, switchMap } from "rxjs";
import { ofType } from "ts-action-operators";

import {
  loadBodenrichtwerte,
  loadGebietDrucksachen,
  loadGebietZahlen,
  loadVergleich,
  loadWahllokale,
} from "./gebiet-actions.js";
import { entscheidungenService } from "../../entscheidungen/service/entscheidungen-service.js";
import { gebietService } from "../service/gebiet-service.js";

/**
 * Die Drucksachen eines Bezirks — über den Dienst von Kapitel 1.
 *
 * KEIN eigener Service: Es ist dieselbe Abfrage auf dieselbe Sammlung, nur mit
 * kleinerem Limit. Ein zweiter Dienst daneben hätte die Bedingungen ein
 * zweites Mal formuliert — und wäre beim nächsten Feld auseinandergelaufen.
 *
 * `switchMap`: Wer schnell zwischen Bezirken wechselt, soll den zuletzt
 * gewählten sehen, nicht den zuletzt eingetroffenen.
 */
export const loadGebietDrucksachenEffect = actions$.pipe(
  ofType(loadGebietDrucksachen.action),
  switchMap(({ payload: { fuer, filter } }) =>
    entscheidungenService.ladeDrucksachen(filter).pipe(
      map((seite) =>
        loadGebietDrucksachen.success({ fuer, items: seite.items, gesamt: seite.gesamt }),
      ),
      catchError((err) => of(loadGebietDrucksachen.fail(err))),
    ),
  ),
);

/** Die Strukturdaten — 28 Zeilen in einem Zug, s. `GebietService`. */
export const loadGebietZahlenEffect = actions$.pipe(
  ofType(loadGebietZahlen.action),
  switchMap(({ payload: gebietId }) =>
    gebietService.ladeStrukturdaten(gebietId).pipe(
      map((zahlen) => loadGebietZahlen.success(zahlen)),
      catchError((err) => of(loadGebietZahlen.fail(err))),
    ),
  ),
);

/** Die Wahllokale — zwei Abfragen, im Dienst verkettet (s. dort). */
export const loadWahllokaleEffect = actions$.pipe(
  ofType(loadWahllokale.action),
  switchMap(({ payload: stadtteilNr }) =>
    gebietService.ladeWahllokale(stadtteilNr).pipe(
      map((lokale) => loadWahllokale.success(lokale)),
      catchError((err) => of(loadWahllokale.fail(err))),
    ),
  ),
);

/**
 * Das Vergleichsgebiet — `switchMap`, weil man sich durch die Liste probiert.
 * Wer schnell wechselt, soll das zuletzt Gewählte sehen, nicht das zuletzt
 * Eingetroffene.
 */
export const loadVergleichEffect = actions$.pipe(
  ofType(loadVergleich.action),
  switchMap(({ payload: gebietId }) =>
    gebietService.ladeVergleich(gebietId).pipe(
      map((zeilen) => loadVergleich.success(zeilen)),
      catchError((err) => of(loadVergleich.fail(err))),
    ),
  ),
);

/**
 * Die Bodenrichtwerte — `switchMap` wie die anderen: Wer schnell zwischen
 * Gebieten wechselt, soll das zuletzt gewählte sehen.
 */
export const loadBodenrichtwerteEffect = actions$.pipe(
  ofType(loadBodenrichtwerte.action),
  switchMap(({ payload: gebietId }) =>
    gebietService.ladeBodenrichtwerte(gebietId).pipe(
      map((b) => loadBodenrichtwerte.success(b)),
      catchError((err) => of(loadBodenrichtwerte.fail(err))),
    ),
  ),
);

export const gebietEffects = [
  loadGebietDrucksachenEffect,
  loadGebietZahlenEffect,
  loadWahllokaleEffect,
  loadVergleichEffect,
  loadBodenrichtwerteEffect,
];
